import { Component, OnInit } from '@angular/core'
import {
  MenuSettingStore,
  MenuSettingSelectorLevel1,
  MenuSettingSelectorLevel2,
  MenuSettingSelectorLevel3,
  MenuSettingSelectorLevel3Colum1,
  MenuSettingSelectorLevel3Colum2,
  SubMenuColumnBanner,
  MenuListStore,
} from '@cms/store/MenuSetting'
import { ModalEditMenuComponent } from '@cms/system/modal/modal-edit-menu/modal-edit-menu.component'
import { NzModalService } from 'ng-zorro-antd'
import { KetMoveLayerManuComponent } from '../move-layer-manu'
import { KetAddMenuPageComponent } from '../add-menu-page'

@Component({
  selector: 'ket-display-menu-detail',
  templateUrl: './display-menu-detail.component.html',
  styleUrls: ['./display-menu-detail.component.scss'],
})
export class KetDisplayMenuDetailComponent implements OnInit {
  constructor(private modal: NzModalService) {}

  sort_options_l2 = {
    emptyInsertThreshold: 20,
    group: {
      name: 'level-2',
      put: ['level-2'],
    },
    handle: '.drag-handle',
    animation: 150,
    onMove: (e: {
      related: {
        className: string
      }
    }) => {
      return e.related.className.includes('drag-handle')
    },
  }

  sort_options_l3 = {
    emptyInsertThreshold: 20,
    handle: '.drag-handle',
    animation: 150,
    onEnd: () => {
      console.log('onEnd', MenuSettingSelectorLevel3.get())
    }
  }

  sort_options_l3_c1 = {
    emptyInsertThreshold: 20,
    group: {
      name: 'level-3c1',
      put: ['level-3c1', 'level-3c2'],
    },
    handle: '.drag-handle',
    animation: 150,
    onEnd: () => {
      // console.log('onEnd', e, MenuSettingSelectorLevel3Colum1.get())
      this.onMoveEnd()
    },
  }

  sort_options_l3_c2 = {
    emptyInsertThreshold: 20,
    group: {
      name: 'level-3c2',
      put: ['level-3c1', 'level-3c2'],
    },
    handle: '.drag-handle',
    animation: 150,
    onEnd: () => {
      // console.log('onEnd', e, MenuSettingSelectorLevel3Colum2.get())
      this.onMoveEnd()
    },
  }

  MenuSettingStore = MenuSettingStore
  SubMenuColumnBanner = SubMenuColumnBanner
  MenuSettingSelectorLevel1 = MenuSettingSelectorLevel1
  MenuSettingSelectorLevel2 = MenuSettingSelectorLevel2
  MenuSettingSelectorLevel3Colum1Data = MenuSettingSelectorLevel3Colum1.get()
  MenuSettingSelectorLevel3Colum2Data = MenuSettingSelectorLevel3Colum2.get()

  data = MenuSettingStore.get().changing.setting[MenuSettingSelectorLevel1.get().page_id]
  sub_menu = MenuSettingStore.get().changing.sub_menu[MenuSettingSelectorLevel1.get().page_id]
  unsubscribe: (() => void)[] = []

  // /assets/images/default-image-banner.png
  ngOnDestroy(): void {
    this.unsubscribe.forEach((unsubscribe) => {
      unsubscribe()
    })
  }

  ngOnInit(): void {
    this.unsubscribe.push(
      MenuSettingSelectorLevel1.subscribe((res) => {
        if (!res) return
        this.data = MenuSettingStore.get().changing.setting[res.page_id]
      }),
    )
    this.unsubscribe.push(
      MenuSettingSelectorLevel3Colum1.subscribe((res) => {
        console.log('MenuSettingSelectorLevel3Colum1', res)
        this.MenuSettingSelectorLevel3Colum1Data = res

        console.log(this.data)
      }),
    )
    this.unsubscribe.push(
      MenuSettingSelectorLevel3Colum2.subscribe((res) => {
        console.log('MenuSettingSelectorLevel3Colum2', res)
        this.MenuSettingSelectorLevel3Colum2Data = res
      }),
    )
  }

  async onMoveEnd() {
    const datac1 = [] as ReturnType<typeof MenuSettingSelectorLevel3Colum1.get>
    const data2 = [] as ReturnType<typeof MenuSettingSelectorLevel3Colum2.get>
    await Promise.all([
      (async () => {
        console.log('set data1', this.MenuSettingSelectorLevel3Colum1Data)
        for (const item of this.MenuSettingSelectorLevel3Colum1Data) {
          if (item && item.page_id) {
            datac1.push(item)
          }
        }
      })(),
      (async () => {
        console.log('set data2', this.MenuSettingSelectorLevel3Colum2Data)
        for (const item of this.MenuSettingSelectorLevel3Colum2Data) {
          if (item && item.page_id) {
            data2.push(item)
          }
        }
      })(),
    ])

    // tick update
    MenuSettingSelectorLevel3Colum1.set(datac1)
    MenuSettingSelectorLevel3Colum2.set(data2)

    const state = MenuSettingStore.get()
    const main_menu = state.changing.menu.find((x) => x.page_id == MenuSettingSelectorLevel1.get().page_id)
    if (!main_menu) return
    const sub_menu = main_menu.childrens.find((x) => x.page_id == MenuSettingSelectorLevel2.get().page_id)
    if (!sub_menu) return
    // sort by MenuSettingSelectorLevel3Colum1 and MenuSettingSelectorLevel3Colum2
    sub_menu.childrens = [
      ...(MenuSettingSelectorLevel3Colum1.get() || []),
      ...(MenuSettingSelectorLevel3Colum2.get() || []),
    ]
    console.log('state', state)
  }

  onMenuDelete(layer: 2 | 3, data: ReturnType<typeof MenuSettingStore.get>['changing']['menu'][0]) {
    console.log('onMenuDelete', layer, data)
    if (layer == 2) {
      MenuSettingSelectorLevel2.set(undefined)
      const state = MenuSettingSelectorLevel1.get()
      state.childrens = state.childrens.filter((x) => x.page_id != data.page_id)
      
      // SubMenuColumnBanner
      const smcb = SubMenuColumnBanner.get()
      for (const key in smcb) {
        const item = smcb[key]
        if (item && item.find((x) => x.page_id == data.page_id)) {
          SubMenuColumnBanner.set({
            ...SubMenuColumnBanner.get(),
            [key]: item.filter((x) => x.page_id != data.page_id),
          })
        }
      }

    } else if (layer == 3) {
      const state = MenuSettingStore.get()
      if (state.changing.setting[MenuSettingSelectorLevel1.get().page_id].type == 'column_banner') {
        for (const menu of state.changing.menu) {
          if (!menu.childrens) continue
          for (const sub_menu of menu.childrens) {
            if (!sub_menu.childrens) continue
            if (sub_menu.childrens.find((x) => x.page_id == data.page_id)) {
              sub_menu.childrens = sub_menu.childrens.filter((x) => x.page_id != data.page_id)
              break
            }
          }
        }
      } else {
        MenuSettingSelectorLevel3.set(undefined)
        const l2_state = MenuSettingSelectorLevel2.get()
        l2_state.childrens = l2_state.childrens.filter((x) => x.page_id != data.page_id)
        MenuSettingSelectorLevel3Colum1.set([
          ...MenuSettingSelectorLevel3Colum1.get().filter((x) => x.page_id != data.page_id),
        ])
        MenuSettingSelectorLevel3Colum2.set([
          ...MenuSettingSelectorLevel3Colum2.get().filter((x) => x.page_id != data.page_id),
        ])
      }
    }

    const list_state = MenuListStore.get()
    list_state.push(data)
    MenuListStore.set(list_state)
  }

  ToggleEnable(data: ReturnType<typeof MenuSettingStore.get>['changing']['menu'][0]) {
    console.log(data)
    console.log('ToggleEnable', MenuSettingStore.get())
  }

  edit(data: ReturnType<typeof MenuSettingStore.get>['changing']['menu'][0], edit_detail = false) {
    let edit_menu = data
    if (edit_detail && ['Products', 'Blog'].includes(data.page)) {
      edit_menu = data.detail
    }
    // console.log(data)
    const modal = this.modal
      .create({
        nzTitle: 'แก้ไขเมนู',
        nzContent: ModalEditMenuComponent,
        nzStyle: { top: '20px' },
        nzWidth: '70%',
        nzKeyboard: false,
        nzMaskClosable: false,
        nzOnOk: (componentInstance) => {
          return componentInstance.ok()
        },
        nzOnCancel: () => {},
        nzComponentParams: {
          data: {
            page: edit_menu,
          },
        },
      })
      .afterClose.subscribe((result) => {
        modal.unsubscribe()
        console.log(result)
      })
  }

  moveLayerMenu(data: ReturnType<typeof MenuSettingStore.get>['changing']['menu'][0]) {
    const modal = this.modal
      .create({
        nzTitle: 'ย้ายตำแหน่ง Layer',
        nzContent: KetMoveLayerManuComponent,
        nzWrapClassName: 'vertical-center-modal',
        nzWidth: '45%',
        nzKeyboard: false,
        nzMaskClosable: false,
        nzComponentParams: {
          data: {
            page: data,
          },
        },
        nzOnOk: (componentInstance) => {
          return componentInstance.ok()
        },
      })
      .afterClose.subscribe((result) => {
        modal.unsubscribe()
        console.log(result)
      })
  }

  AddSubMenuL3(page_id: number) {
    MenuSettingSelectorLevel2.set(undefined)
    MenuSettingSelectorLevel3.set(undefined)

    // find layer 2
    for (const item of MenuSettingStore.get().changing.menu) {
      for (const subitem of item.childrens) {
        if (subitem.page_id == page_id) {
          MenuSettingSelectorLevel2.set(subitem)
          break
        }
      }
    }

    this.AddSubMenu(3)
  }

  AddSubMenu(layer: 2 | 3, column?: number) {
    let sub_id = 0

    if (layer == 2) {
      sub_id = MenuSettingSelectorLevel1.get().page_id
    } else if (layer == 3) {
      sub_id = MenuSettingSelectorLevel2.get().page_id
    }

    if (!sub_id) {
      return
    }
    this.modal.create({
      nzTitle: 'Add Menu',
      nzContent: KetAddMenuPageComponent,
      nzWrapClassName: 'vertical-center-modal',
      nzWidth: '45%',
      nzKeyboard: false,
      nzMaskClosable: false,
      nzComponentParams: {
        add_type: 'sub',
        sub_id,
        column,
      },
      nzOnOk: (componentInstance) => {
        return componentInstance.ok()
      },
    })
  }

  generateArray(value: number): number[] {
    return new Array(value)
  }

  onMoveNext(index: number, p: 'next' | 'prev') {
    index = index+1
    const old_index = index
    const new_index = p == 'next' ? index + 1 : index - 1
    const old_data = SubMenuColumnBanner.get()[old_index]
    const new_data = SubMenuColumnBanner.get()[new_index]
    if (!old_data || !new_data) return
    if (old_data.length == 0 || new_data.length == 0) return
    SubMenuColumnBanner.set({...SubMenuColumnBanner.get(), [old_index]: new_data, [new_index]: old_data})
    const state = MenuSettingStore.get()
    let count = 0
    for (const item of Object.values(SubMenuColumnBanner.get())) {
      count++
      for (const sub_item of item) {
        state.changing.sub_menu[sub_item.page_id].column = count
        console.log(`current column ${sub_item.display_name_lang1 || sub_item.lang1}`, state.changing.sub_menu[sub_item.page_id].column)
      }
    }
    MenuSettingStore.set(state)

    // animate background color
    const new_element = document.getElementById(`menu_list_tab_colum_banner_${new_index}`)
    if (!new_element) return
    count = 0
    for (const item of Object.values(SubMenuColumnBanner.get())) {
      count++
      for (const _ of item) {
        if (count == new_index) continue
        const element = document.getElementById(`menu_list_tab_colum_banner_${count}`)
        if (!element) continue
        element.style.transition = 'opacity 0.01s ease-in-out'
        element.style.opacity = '0.5'
        setTimeout(() => {
          element.style.transition = 'opacity 0.5s ease-in-out'
          element.style.opacity = '1'
        }, 200)
      }
    }
    new_element.style.transition = 'background-color 0.01s ease-in-out'
    new_element.style.backgroundColor = '#B12629'
    setTimeout(() => {
      new_element.style.transition = 'background-color 0.3s ease-in-out'
      new_element.style.backgroundColor = 'white'
    }, 200)
  }
}
